"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCurrencyAbbreviationFromName = exports.getCurrencyList = exports.getCurrencyAbbreviation = exports.getCurrency = void 0;
var currencyMap_1 = __importDefault(require("./currencyMap"));
var getCountry_1 = require("./getCountry");
function getCurrency(currencyAbbr) {
    return currencyMap_1.default[currencyAbbr];
}
exports.getCurrency = getCurrency;
function getCurrencyAbbreviation(countryName) {
    var country = getCountry_1.getCountry(countryName);
    if (country) {
        return country.currency;
    }
    return undefined;
}
exports.getCurrencyAbbreviation = getCurrencyAbbreviation;
// Returns a list of currency objects.
function getCurrencyList() {
    var currencyArray = Object.keys(currencyMap_1.default).map(function (currencyAbbr) { return ({
        abbr: currencyAbbr,
        name: currencyMap_1.default[currencyAbbr].name,
        symbolFormat: currencyMap_1.default[currencyAbbr].symbolFormat,
    }); });
    return currencyArray;
}
exports.getCurrencyList = getCurrencyList;
function getCurrencyAbbreviationFromName(currencyName) {
    for (var _i = 0, _a = Object.entries(currencyMap_1.default); _i < _a.length; _i++) {
        var _b = _a[_i], abbr = _b[0], details = _b[1];
        if (details.name === currencyName) {
            return abbr;
        }
    }
    return undefined;
}
exports.getCurrencyAbbreviationFromName = getCurrencyAbbreviationFromName;
